import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import style from './style.scss';

class Button extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
  };

  /**
   * @returns {JSX.Element}
   */
  render() {
    const { children, className, ...props } = this.props;
    return (
      <button {...props} className={classNames('btn', className)}>
        {children}
      </button>
    );
  }
}

export default Button;
